import axios from "axios";

function saveConsultation(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3070";
      axios
        .post(process.env.ROOT_API + "/consultations/insert", obj.body, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in saveConsultation: ", err);
    }
  });
}

function updateConsultation(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3072";
      axios
        .put(
          process.env.ROOT_API + "/consultations/update/" + obj.id,
          obj.body,
          {
            headers: {
              Authorization: obj.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in updateConsultation: ", err);
    }
  });
}

function deleteConsultation(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3098";
      axios
        .delete(process.env.ROOT_API + "/consultations/delete/" + obj.id, {
          data: obj.body,
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in deleteConsultation: ", err);
    }
  });
}

function queryConsultation(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3071";
      axios
        .post(
          process.env.ROOT_API + "/consultations/query/" + obj.active,
          obj.body,
          {
            headers: {
              Authorization: obj.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in queryConsultation: ", err);
    }
  });
}

function person_query(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3034";
      axios
        .put(process.env.ROOT_API + "/persons/query", objAux, {
          headers: {
            Authorization: objAux.token
          }
        })
        .then(result => {
          resolve(result.data.documents[0]);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("Person_Query: ", error);
    }
  });
}

function personInsert(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3033";
    axios
      .post(process.env.ROOT_API + "/persons/insert", objData.body, {
        headers: {
          Authorization: objData.token
        }
      })
      .then(result => {
        resolve(result.data.documents[0]);
      })
      .catch(error => {
        reject(error);
      });
  });
}

function contacts_confirmed(objAux) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3096";
      axios
        .get(
          process.env.ROOT_API +
            "/contacts/confirm/" +
            objAux.user1 +
            "/" +
            objAux.user2,
          {
            headers: {
              Authorization: objAux.token
            }
          }
        )
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response.data.message);
        });
    } catch (error) {
      console.log("contacts_confirmed: ", error);
    }
  });
}

function contactInsert(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3060";
    axios
      .post(process.env.ROOT_API + "/contacts/insert", objData, {
        headers: {
          Authorization: objData.token
        }
      })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
}

function listInstitution(objData) {
  return new Promise((resolve, reject) => {
    let port = "";
    if (process.env.ROOT_API.includes("viewmedonline")) port = ":3042";
    axios
      .post(process.env.ROOT_API + "/contacts/institutions/list", objData, {
        headers: {
          Authorization: objData.token
        }
      })
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
}

function getDiagnoses(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3110";
      axios
        .put(process.env.ROOT_API + "/diagnoses/query", obj.body, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in getDiagnoses: ", err);
    }
  });
}

export {
  saveConsultation,
  updateConsultation,
  queryConsultation,
  person_query,
  personInsert,
  contacts_confirmed,
  contactInsert,
  deleteConsultation,
  listInstitution,
  getDiagnoses
};



// WEBPACK FOOTER //
// ./src/components/consultation/consultationServ.js